// src/api.js
import axios from 'axios';

// In production we serve frontend and backend from the same origin.
// Default to a relative base so calls go to the same host (allowed by CSP 'self').
// If you need to target a separate API host, set REACT_APP_API_URL in the environment.
const API_URL = process.env.REACT_APP_API_URL || '';

export const login = (username, password) => {
  return axios.post(`${API_URL}/api/auth/login`, { username, password });
};
